/**
 * Determines the current questions for a quiz.
 * @param {object} currentAssignment
 * @param {object} data
 * @param {boolean} isCustomQuiz
 * @param {string} quizId
 * @returns {Array} an array of current questions
 */
const getCurrentQuizQuestions = ({
  currentAssignment,
  data,
  isCustomQuiz,
  quizId,
}) => {
  if (!data) return null;

  if (isCustomQuiz) {
    const customSelections = currentAssignment?.activity_element_selections;
    const currentLeveledQuizSelections = customSelections?.[quizId]?.[data.id];

    const filteredQuestionsBySelections = data.questions.filter((question) => {
      return currentLeveledQuizSelections?.includes(question.id);
    });

    // Preserve question order based on question.position property
    const sortedQuestions = filteredQuestionsBySelections.sort((a, b) => {
      return a.position - b.position;
    });

    return sortedQuestions;
  } else {
    return data.questions;
  }
};

export default getCurrentQuizQuestions;
